"use strict";

import angular from "angular";

/**
 * detectionPlatform
 * Verifica qual plataforma está rodando, electron ou web
 */
export class detectionPlatform {
    /**
     * constructor
     */
    constructor() {}

    /**
     * isElectron
     * @return {Boolean} true/false
     */
    isElectron() {
        return navigator.userAgent.indexOf("Electron") > -1;
    }
}
angular.module("nucont.shared").service("detectionPlatform", [detectionPlatform]);
